import { ScItem, ShortPhraseFields } from '@/types/sitecore';
import { CaseType } from '@/types';
import utils from '@/utils/index';

export const getVal = (item?: ScItem<ShortPhraseFields> | null, caseType?: CaseType) => {
  let val: string | null | undefined = item?.fields?.phrase?.value;
  if (!val) return val;
  if (caseType) val = utils.string.toCase(val, caseType);
  return val;
};
export const getVals = (
  items: Array<ScItem<ShortPhraseFields> | null | undefined>,
  caseType?: CaseType
) => {
  const result = [];
  for (const item of items) {
    result.push(getVal(item, caseType));
  }
  return result;
};
export const getValByFields = (fields: any, ...cfgFieldNames: string[]) => {
  const result = [];
  for (const fn of cfgFieldNames) {
    if (!fields) result.push(undefined);
    result.push(getVal(fields[fn]));
  }
  return result;
};
export const getValByFields1 = (fields: any, keys: Array<string>, caseType?: CaseType) => {
  const result = getValByFields(fields, ...keys);
  return result.map((x) => utils.string.toCase(x, caseType));
};
export const getText = (item?: ScItem<ShortPhraseFields> | null, caseType?: CaseType) => {
  if (!item?.fields) return undefined;
  return utils.string.toCase(item.fields.text.value, caseType);
};
export const getTexts = (
  items: Array<ScItem<ShortPhraseFields> | null | undefined>,
  caseType?: CaseType
) => {
  const result = [];
  for (const item of items) {
    result.push(getText(item, caseType));
  }
  return result;
};
export const textByFields = (fields: any, ...cfgFieldNames: string[]) => {
  const result = [];
  for (const fn of cfgFieldNames) {
    if (!fields) result.push(undefined);
    result.push(getText(fields[fn]));
  }
  return result;
};
export const tryVal = (...items: Array<ScItem<ShortPhraseFields> | undefined | null>) => {
  for (const item of items) {
    const data = getVal(item);
    if (data) return data;
  }
  return undefined;
};
export const build = (phrase?: string, text?: string) => {
  if (!phrase) {
    return {
      id: '',
      name: '',
      fields: undefined,
    } as ScItem<ShortPhraseFields>;
  }
  return {
    id: phrase,
    name: phrase,
    fields: {
      phrase: {
        value: phrase,
      },
      text: {
        value: utils.string.ifEmpty(text, phrase),
      },
    },
  } as ScItem<ShortPhraseFields>;
};
